import { ListSortMethod, List } from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";
import { forkJoin, Observable } from "rxjs";
import { ListAction, fetchListSuccess } from "../List";
import { GameAction, GameActionTypes } from "./Game";
import { removeFromLastPlayed as apiRemoveFromLastPlayed } from "@blacknut/javascript-sdk/dist/api/removeFromLastPlayed";
export const dismissRemoveGamesFromLastPlayedError = () => {
  return (dispatch: Dispatch<GameAction>) => {
    dispatch({ type: GameActionTypes.BULK_REMOVE_FROM_LAST_PLAYED_ERROR });
  };
};
// FIXME provide unit test
export const removeGamesFromLastPlayed = (
  { list, sort }: { sort: ListSortMethod; list: List },
  games: Set<string>,
) => {
  return (dispatch: Dispatch<GameAction | ListAction>) => {
    return new Promise<void>((resolve, reject) => {
      dispatch({
        type: GameActionTypes.BULK_REMOVE_FROM_LAST_PLAYED_REQUEST,
        ids: games,
      });

      const sub: Array<Observable<unknown>> = [];
      games.forEach((id) => {
        sub.push(apiRemoveFromLastPlayed(id));
      });

      // Dispatch the sooner the removal success
      dispatch(
        fetchListSuccess(list.uuid, sort, {
          ...list,
          tiles: list.tiles.filter((tile) => !games.has(tile.game!.id)),
          total: list.total - games.size,
        }),
      );

      forkJoin(sub).subscribe({
        next: () => {
          dispatch({
            type: GameActionTypes.BULK_REMOVE_FROM_LAST_PLAYED_SUCCESS,
            ids: games,
          });
          resolve();
        },
        error: (error) => {
          dispatch({
            type: GameActionTypes.BULK_REMOVE_FROM_LAST_PLAYED_ERROR,
            error,
          });
          reject(error);
        },
      });
    });
  };
};
